/*
 * Wraps SATComponent.prototype.renderVals to add a "See more" toggle to the
 * 1990s terminal's single-record view (snippets/sat-term-90s.liquid's
 * {{ rec90.desc }} block) — same problem as the main product detail modal
 * (see assets/sat-detail-truncate-patch.js): rec90.desc is built in
 * sat-app.js from `p.detail || p.blurb || ''` (renderVals ~line 3347), the
 * same long-form field, un-truncated, and some listings run to a genuinely
 * long single paragraph that turned this "GeoCities page" record view into
 * a wall of text.
 *
 * Mirrors sat-detail-truncate-patch.js's exact approach — same PREVIEW_LEN,
 * same whole-word truncate helper, same two-field expanded-state tracking
 * (term90MoreOpen alone would stay expanded across switching to a
 * *different* record without resetting; term90MoreFor records which
 * record's code the expansion was for, so a mismatch collapses
 * automatically). Kept as its own small patch rather than folded into the
 * existing one so each stays scoped to the one screen it touches.
 */
(function () {
  'use strict';
  if (!window.SATComponent) { return; }

  var PREVIEW_LEN = 220;

  function truncate(text, len) {
    if (text.length <= len) return text;
    var cut = text.slice(0, len);
    var lastSpace = cut.lastIndexOf(' ');
    if (lastSpace > len * 0.6) cut = cut.slice(0, lastSpace);
    return cut.replace(/[,;:.\s]+$/, '') + '…';
  }

  var orig = window.SATComponent.prototype.renderVals;
  window.SATComponent.prototype.renderVals = function () {
    var out = orig.call(this);
    var self = this;
    var s = this.state;

    if (!out.rec90 || !out.rec90.code) {
      out.term90MoreShow = 'none';
      return out;
    }

    var fullText = out.rec90.desc || '';
    var isLong = fullText.length > PREVIEW_LEN;
    var recordCode = out.rec90.code;
    var isOpen = s.term90MoreFor === recordCode && !!s.term90MoreOpen;

    out.rec90 = Object.assign({}, out.rec90, {
      desc: (isLong && !isOpen) ? truncate(fullText, PREVIEW_LEN) : fullText
    });
    out.term90MoreShow = isLong ? 'inline' : 'none';
    out.term90MoreLabel = isOpen ? 'See less' : 'See more';
    out.toggleTerm90More = function () {
      self.setState({ term90MoreFor: recordCode, term90MoreOpen: !isOpen });
    };

    return out;
  };
})();
